module.exports = __webpack_public_path__ + "static/media/hud_north.6e9ea251.svg";